import { MarketingButtons } from "../../components/MarketingButtons";
import { PageContent } from "../../pages/templates/PageLayout";
import featureCards from "../featureCards";
import Images from "../images";
import { exampleLinks } from "./exampleLinks";

const data: PageContent = {
  style: "light",
  sections: [
    {
      type: "HeroSection",
      title: "Build better brands",
      subtitle: `Save time and deliver more value to your clients by using Lingo to build, manage and share digital style guides and brand systems. [See an example](${exampleLinks.agencies}).`,
      primaryButton: MarketingButtons.getStarted,
      secondaryButton: MarketingButtons.bookDemo,
      image: {
        src: Images.Solutions.BrandGuidelines.hero,
        alt: "Brand guidelines",
      },
    },
    {
      type: "MediaSection",
      title: "No more stale PDF style guides for your clients",
      subtitle:
        "All the tools you need to create a centralized set of living brand guidelines that are easy to update and intuitive for your clients to use.",
      layoutDirection: "image-left",
      body: {
        style: "tabList",
        items: [
          {
            title: "A solution for all your clients",
            body: "Inside a single Lingo workspace you can create, manage and share an unlimited number of style guides and asset libraries.",
            image: {
              src: Images.Solutions.agencies_allClients,
              alt: "A solution for all your clients",
            },
          },
          {
            title: "Always up to date",
            body: "Need to make an update to a style guide? Simply make the change and you're done. No more sending countless versions as email attachments.",
            image: {
              src: Images.Solutions.agencies_upToDate,
              alt: "Always up to date",
            },
          },
          {
            title: "Automatic file conversion",
            body: "Lingo automatically converts files for you so you don't have to. Your clients will be able to find the file they need in the format and size they need, all without needing your help.",
            image: {
              src: Images.Solutions.agencies_fileConversion,
              alt: "Automatic file conversion",
            },
          },
          {
            title: "Affiliate program",
            body: "Make money by using Lingo. If you introduce Lingo to one of your clients, we'll share a percentage of revenue back with you!",
            image: {
              src: Images.Solutions.agencies_affiliateProgram,
              alt: "Affiliate program for agencies",
            },
          },
        ],
      },
    },
    {
      type: "CardSection",
      title: "More powerful features to manage your assets",
      footerButton: {
        link: "/product/features",
        text: "View all features",
        buttonStyle: "outline",
      },
      items: [
        featureCards.customBranding,
        featureCards.customDomains,
        featureCards.usageGuidelines,
      ],
    },
    {
      type: "FaqSection",
      title: "Agency Digital Asset Management FAQ",
      faqs: [
        {
          question: "How can Lingo help my agency manage multiple clients efficiently?",
          answer:
            "Lingo allows agencies to manage all client assets from a single platform, providing dedicated, branded portals for each client. With structured kits, self-serve access, and automation features, your team spends less time handling file requests and more time on the clients needs.",
        },
        {
          question: "Can clients access their assets without needing a login?",
          answer:
            "Yes! Lingo offers public, private, and password-protected access options. You can create branded, shareable portals for clients, ensuring they always have the latest brand assets, without constant back-and-forth requests.",
        },
        {
          question: "How does Lingo help maintain brand consistency across different clients?",
          answer:
            "With Lingo, you can pair brand guidelines with assets in interactive digital kits. Clients get clear usage instructions alongside their files, marrying content to the context, ensuring consistency across all marketing, sales, and creative efforts.",
        },
        {
          question: "Can Lingo track how clients are using shared assets?",
          answer:
            "Absolutely! Lingo provides real-time analytics so you can see which assets are being accessed and downloaded the most. This helps agencies understand client engagement and optimize their asset delivery strategy.",
        },
        {
          question: "Does Lingo support integrations with the tools my agency already uses?",
          answer:
            "Yes! Lingo integrates with Canva, Figma, Google Drive, and Dropbox, so you can sync assets across platforms without manually updating multiple systems.",
        },
        {
          question: "Can my agency generate additional revenue with Lingo?",
          answer:
            "Yes! Lingo offers a 40% revenue share on referred clients, meaning your agency can monetize DAM recommendations while providing clients with a better asset management solution.",
        },
        {
          question: "How does Lingo improve collaboration between my team and our clients?",
          answer:
            "By eliminating scattered ZIP files and static PDFs, Lingo creates a centralized, searchable hub for both your team and clients. With automatic file conversions, self-serve downloads, and structured asset kits, collaboration becomes seamless and frustration-free.",
        },
      ],
    },
    { type: "CtaSection" },
  ],
};

export default data;
